import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';
import type { EmployeeInfoDTO, Feature, OrderConfig, UserLoginInfo, User } from '../types/User';
import type { CustomerInfo } from 'shared/src/types/CustomerInfo';

export interface UserState {
  user: User | undefined;
  account: CustomerInfo | undefined;
  parentAccount?: CustomerInfo | undefined;
  enabled: boolean;
  orderConfigs?: OrderConfig[];
  loading?: boolean;
  features: Feature[];
  loadingUserError: string | undefined;
  employeeInfo: EmployeeInfoDTO | undefined;
}

const createDefaultUserState = (): UserState => ({
  user: undefined,
  account: undefined,
  enabled: false,
  orderConfigs: [],
  loading: false,
  features: [],
  loadingUserError: undefined,
  employeeInfo: undefined,
});

const defaultUserState = createDefaultUserState();

const slice = createSlice({
  name: 'user',
  initialState: defaultUserState,
  reducers: {
    loadingUser: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setUser: (state, action: PayloadAction<UserLoginInfo>) => {
      state.user = action.payload.user;
      state.account = action.payload.account;
      state.parentAccount = action.payload.parentAccount;
      state.enabled = action.payload.enabled;
      state.orderConfigs = action.payload.orderConfigs;
      state.features = action.payload.features;
      state.employeeInfo = action.payload.employeeInfo;
    },
    logoutUser: (state) => {
      const newState = createDefaultUserState();
      state.user = newState.user;
      state.account = newState.account;
      state.parentAccount = newState.parentAccount;
      state.enabled = newState.enabled;
      state.orderConfigs = newState.orderConfigs;
      state.features = newState.features;
      state.loading = newState.loading;
      state.loadingUserError = newState.loadingUserError;
    },
    setLoadingUserError: (state, action: PayloadAction<string | undefined>) => {
      state.loadingUserError = action.payload;
    },
  },
});

export default slice.reducer;

export const { loadingUser, setUser, logoutUser, setLoadingUserError } = slice.actions;
